import React from 'react';
import PropTypes from 'prop-types';
import ImageDataPoint from './DataPoint';

const ImageTimeline = ({ Dataset, graphId, cameraName, timelineValues }) => {
  const data = Dataset.Data; //useSelector(getObservationData(DatasetId, startPoint, endDate / 1000));

  const startPoint = timelineValues.min;
  const endPoint = timelineValues.max;
  const leftMargin = timelineValues.left;
  const rightMargin = timelineValues.right;

  const visibleData = data.filter((dataItem) => {
    return dataItem.x > startPoint && dataItem.x < endPoint;
  });

  const range = endPoint - startPoint;

  return (
    <>
      {visibleData.length > 0 ? (
        <>
          <div>
            <b>
              <small>{cameraName}</small>
            </b>
          </div>
          <div className="image-timeline" style={{ left: leftMargin + 'px', right: rightMargin + 'px' }}>
            <div className="image-timeline__background"></div>
            <div className="image-timeline__data-points">
              {visibleData.map((dataPoint, idx) => {
                let position = ((dataPoint.x - startPoint) / range) * 100;
                return (
                  <ImageDataPoint
                    key={idx}
                    position={position}
                    url={dataPoint.Value}
                    timestamp={dataPoint.x}
                    cameraName={cameraName}
                    tooltipId={graphId}
                    point_color={Dataset.color}
                  />
                );
              })}
            </div>
          </div>
        </>
      ) : (
        <div></div>
      )}
    </>
  );
};

ImageTimeline.propTypes = {
  Dataset: PropTypes.any.isRequired,
  graphId: PropTypes.any.isRequired,
  cameraName: PropTypes.any.isRequired,
  timelineValues: PropTypes.any.isRequired,
};

export default ImageTimeline;
